






























import Vue from "vue";
import USER_GROUPS_QUERY from "../graphql/UserGroupsQuery.gql";
import GroupList from "@/components/GroupList.vue";
import { GetUserGroups_userGroups } from "@/graphql/generatedTypes/GetUserGroups";
import EditableText from "@/components/EditableText.vue";

export default Vue.extend({
  name: "MyGroupsIndex",
  components: { EditableText, GroupList },
  apollo: {
    userGroups: {
      fetchPolicy: "no-cache",
      query: USER_GROUPS_QUERY
    }
  },
  data() {
    return {
      userGroups: [] as GetUserGroups_userGroups[]
    };
  },
  watch: {
    userGroups() {
      if (this.$apollo.queries.userGroups.loading) {
        return;
      } else if (this.userGroups.length == 0) {
        this.$alertService.addAlert({
          message: "You are not currently in a intro, please find one below.",
          type: "success"
        });
        // this.$router.push({ name: "groups_path" });
      }
    }
  }
});
